/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Google_Play_StoreInputs */

const en_plan_google_play_store = /** @type {(inputs: Plan_Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

const es_plan_google_play_store = /** @type {(inputs: Plan_Google_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store`)
};

/**
* | output |
* | --- |
* | "Google Play Store" |
*
* @param {Plan_Google_Play_StoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_google_play_store = /** @type {((inputs?: Plan_Google_Play_StoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Google_Play_StoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_google_play_store(inputs)
	return en_plan_google_play_store(inputs)
});